"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.demoResetSchema = void 0;
// Wire shape of Screen 8's `Reset demo data` and the Synthetic Data tab's `Regenerate` (SPEC §8 Screen 8,
// §9 `POST /api/demo/reset`, §10.1, §14.4; D-1074; J-041), served at `POST /api/v1/demo-resets` (D-973).
// The request has no body: the year is the stored synthetic document's `performance_year`. The response
// carries batch ids, source types and counts only; every row it describes is synthetic.
const zod_1 = require("zod");
const calculations_js_1 = require("./calculations.js");
const count = zod_1.z.number().int().min(0);
/** One generated file as the normal loader loaded it (SPEC §10.1 "the same loaders"). */
const demoResetLoadSchema = zod_1.z.object({
    sourceType: zod_1.z.string(),
    batchId: zod_1.z.number().int(),
    performanceYear: zod_1.z.number().int(),
    rowsRead: count,
    rowsLoaded: count,
    rowsRejected: count,
});
exports.demoResetSchema = zod_1.z
    .object({
    /** The earlier synthetic batches the reset marked SUPERSEDED. */
    supersededBatches: count,
    /** In load order: the organization lists, group setup, benchmarks, encounters, instances. */
    loads: zod_1.z.array(demoResetLoadSchema),
    /** One calculation per year the loads wrote (the demo has one). */
    calculations: zod_1.z.array(calculations_js_1.calculationSchema),
})
    .meta({ id: "AcoDemoReset" });
//# sourceMappingURL=demo-resets.js.map